// src/pages/DemoLogin.jsx
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./DemoLogin.css";

import logo from "../assets/panelzero-icon.png";
import { DEMO_CREDS } from "../lib/demoData";

const STORAGE_KEY = "pz-demo-auth";

export function isDemoAuthed() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "ok";
  } catch {
    return false;
  }
}

export function setDemoAuthed(flag) {
  try {
    if (flag) sessionStorage.setItem(STORAGE_KEY, "ok");
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
}

export default function DemoLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [shake, setShake] = useState(false);
  const [booting, setBooting] = useState(false);
  const nav = useNavigate();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    const u = username.trim().toLowerCase();
    const p = password;
    if (u === DEMO_CREDS.username && p === DEMO_CREDS.password) {
      setBooting(true);
      setDemoAuthed(true);
      // tiny stagger so the boot animation is noticed before navigating
      setTimeout(() => nav("/demo"), 900);
    } else {
      setError("Invalid username or password.");
      setShake(true);
      setTimeout(() => setShake(false), 420);
    }
  };

  return (
    <div className="pzl-root">
      <div className="pzl-bg" aria-hidden="true">
        <div className="pzl-orb pzl-orb-a" />
        <div className="pzl-orb pzl-orb-b" />
        <div className="pzl-grid" />
      </div>

      <Link to="/" className="pzl-home">&larr; Back to site</Link>

      <main className={`pzl-card ${shake ? "is-shake" : ""} ${booting ? "is-booting" : ""}`}>
        <div className="pzl-brand">
          <img src={logo} alt="" className="pzl-logo" />
          <div className="pzl-brandtext">
            <div className="pzl-brandname">PanelZero</div>
            <div className="pzl-brandsub">Production-style demo tenant</div>
          </div>
        </div>

        <h1 className="pzl-title">Live Demo Access</h1>
        <p className="pzl-sub">
          This console is populated with a synthetic tenant. No PHI. Please use the reviewer
          credentials sent to you separately.
        </p>

        <form onSubmit={onSubmit} className="pzl-form" noValidate>
          <label className="pzl-label">
            <span>Username</span>
            <input
              ref={inputRef}
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => { setUsername(e.target.value); setError(""); }}
              placeholder="yc"
            />
          </label>

          <label className="pzl-label">
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              placeholder="••••••••••••••"
            />
          </label>

          {error && <div className="pzl-error" role="alert">{error}</div>}

          <button className="pzl-btn" type="submit">
            {booting ? (
              <>
                <span className="pzl-spin" aria-hidden="true" />
                Booting demo tenant…
              </>
            ) : (
              <>
                Enter demo
                <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                  <path d="M5 12h12M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </>
            )}
          </button>
        </form>

        <div className="pzl-note">
          Sessions are in-memory. No PHI is transmitted or stored — the tenant is synthetic.
          Lost your credentials?{" "}
          <a href="mailto:adcheng4@illinois.edu?subject=PanelZero%20demo%20access">adcheng4@illinois.edu</a>.
        </div>
      </main>

      <footer className="pzl-footer">
        <span>PanelZero, Inc. · HIPAA-aligned · SOC 2 Type II in progress</span>
      </footer>
    </div>
  );
}
